import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Marca } from '../../../comun/model/autos.model';
import { AutosBusquedaStoreService } from '../../services/store/autos-busqueda-store.service';
import { CaCardComponent } from '@global-front-components/ui/card';
import { TranslateModule } from '@ngx-translate/core';
import { CaSelectComponent } from '@global-front-components/ui/select';
import { CaFormFieldComponent } from '@global-front-components/ui/form-field';

@Component({
	selector: 'app-marcas',
	standalone: true,
	imports: [
		CommonModule, 
		CaCardComponent,
		CaFormFieldComponent,
		CaSelectComponent,
		TranslateModule
	],
	templateUrl: './marcas.component.html',
	styleUrls: ['./marcas.component.scss', '../buscar-version-manual/buscar-version-manual.component.scss']
})
export class MarcasComponent implements OnInit{
	@Output() pasoSeleccionado = new EventEmitter<void>();

	@ViewChild(CaSelectComponent)
	private selectMarcas: CaSelectComponent;

	public marcasDestacadas: Marca[];
	public marcas: Marca[];

	constructor(private autosStore: AutosBusquedaStoreService) { }

	ngOnInit(): void {
		this.autosStore.marcasDestacadasSubject$.subscribe({
			next: (marcasDestacadas) => {
				this.marcasDestacadas = marcasDestacadas;
			},
			error: (err) => console.error('Error recuperando marcas:', err),
		});
		this.autosStore.marcasSubject$.subscribe({
			next: (marcas) => {
				this.marcas = marcas;
			},
			error: (err) => console.error('Error recuperando marcas:', err),
		});
	}

	seleccionarMarcaDestacada(marca: Marca): void {
		this.selectMarcas?.writeValue(marca.nombreMarca);
		this.seleccionarMarca(marca.nombreMarca);
	}

	seleccionarMarca(nombreMarca: string): void {
		if (!nombreMarca) {
			return;
		}	
		const marcaDestacada = this.marcasDestacadas.find(m => m.nombreMarca === nombreMarca);			
		this.autosStore.setMarcaSeleccionada(nombreMarca);
		if (marcaDestacada?.idMarca) {
			this.autosStore.getModelosDestacados(this.autosStore.getIdTipoVehiculoSeleccionado(), marcaDestacada.idMarca);
		}
		this.autosStore.getModelos(this.autosStore.getIdTipoVehiculoSeleccionado(), nombreMarca);

		this.pasoSeleccionado.emit();
	}
}
